if (!customElements.get('mobile-sticky-bar')) {
  customElements.define(
    'mobile-sticky-bar',
    class MobileStickyBar extends HTMLElement {
      constructor() {
        super();

        this.classes = {
          enabled: 'mobile-sticky-bar-enabled',
          isShow: 'mobile-sticky-bar-up',
          isHide: 'mobile-sticky-bar-down',
        };

        this.compareToggleUnsubscriber = FoxTheme.pubsub.subscribe('compare:toggle', this.onCompareToggle.bind(this));
      }

      compareToggleUnsubscriber = undefined;

      connectedCallback() {
        document.body.classList.add(this.classes.enabled);
        if (this.isCompareBarShowing()) {
          this.hide();
        } else {
          this.show();
        }

        this.lastScrollTop = 0;
        this.scrollHandler = FoxTheme.utils.debounce(this.onScrollHandler.bind(this), 10);
        this.init();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.scrollHandler);

        if (this.compareToggleUnsubscriber) {
          this.compareToggleUnsubscriber();
        }
      }

      init() {
        this.calculateHeight();
        window.addEventListener('scroll', this.scrollHandler, false);
      }

      calculateHeight() {
        requestAnimationFrame(() => {
          document.documentElement.style.setProperty('--mobile-sticky-bar-height', `${this.offsetHeight}px`);
        });
      }

      isCompareBarShowing() {
        return document.body.classList.contains('is-product-comparing');
      }

      onCompareToggle(event) {
        if (event.isActive) {
          this.hide();
        } else {
          this.show();
        }
      }

      onScrollHandler() {
        if (this.isCompareBarShowing()) {
          this.hide();
          return;
        }

        const offsetTop = document.getElementById('mobileNavStatic').offsetTop;
        const scrollTop = window.scrollY;
        const pointTouch = offsetTop - scrollTop - window.innerHeight;

        requestAnimationFrame(() => {
          // EUM (2026-10-01): con la regla del header del tema (header.js, scrollThreshold). Antes CADA píxel hacia abajo
          // la escondía y cada píxel hacia arriba la sacaba: un rebote en cada gesto («agresivo», owner). Ahora se
          // esconde tras 200 px seguidos hacia abajo y vuelve con un gesto claro hacia arriba (≥ 8 px) o cerca del inicio.
          const delta = scrollTop - this.lastScrollTop;
          this.lastScrollTop = scrollTop;
          if (pointTouch <= 0) {
            this.hide(); // llegaste al final de la página: como siempre, la barra no tapa el footer
            return;
          }
          if (scrollTop < 80) {
            this.show();
            return;
          }
          if (delta === 0) return;
          const direction = delta > 0 ? 'down' : 'up';
          if (direction !== this.scrollDirection) {
            this.scrollDirection = direction;
            this.scrollDistance = 0;
          }
          this.scrollDistance = (this.scrollDistance || 0) + Math.abs(delta);

          if (direction === 'up' && this.scrollDistance >= 8) {
            this.show();
          } else if (direction === 'down' && this.scrollDistance >= 200) {
            this.hide();
          }
        });
      }

      show() {
        document.body.classList.remove(this.classes.isHide);
        document.body.classList.add(this.classes.isShow);
      }

      hide() {
        document.body.classList.remove(this.classes.isShow);
        document.body.classList.add(this.classes.isHide);
      }
    }
  );
}
